import { Unit } from '@src/types';
import { useEffect, useState, useMemo } from 'react';
import styles from './OverviewForm.module.scss';

type Props = {
  unit?: any;
  numberOfLessons?: number | 0;
  loading?: boolean
};

function timeCalc(lastTime: number) {
  var currentTime = new Date ().getTime ();
  var agotime = Math.floor ((currentTime -lastTime) / 31556926000);
  var timeindex = 'y ago';
  if ( isNaN(agotime)) {
    return "";
  }
  if (agotime === 0) {
    agotime = Math.floor ((currentTime -lastTime) / 2629743000);
    timeindex = 'mo ago';
  }
  if (agotime === 0) {
    agotime = Math.floor ((currentTime -lastTime) / 604800000);
    timeindex = 'w ago';
  }
  if (agotime === 0) {
    agotime = Math.floor ((currentTime -lastTime) / 86400000);
    timeindex = 'd ago';
  }
  if (agotime === 0) {
    agotime = Math.floor ((currentTime -lastTime) / 3600000);
    timeindex = 'h ago';
  }
  if (agotime === 0) {
    agotime = Math.floor ((currentTime -lastTime) / 60000);
    timeindex = 'm ago';
  }
  if (agotime === 0) {
    agotime = Math.floor ((currentTime -lastTime) / 1000);
    timeindex = 's ago';
  }
  return agotime + timeindex;
}

function OverviewForm(props: Props) {
  const { unit, numberOfLessons, loading } = props;

  const [box1, setBox1] = useState<string[]>([]);
  const [box2, setBox2] = useState<string[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [skillsHeading, setSkillsHeading] = useState('This Unit teaches skills for:');
  const [helpfulHeading, setHelpfulHeading] = useState('This Unit is helpful for students who:');
  const [competency, setCompetency] = useState<string[]>([]);
  
  useEffect(() => {
    if (unit) {
      setTags(JSON.parse(unit?.tags || '[]'));
      setBox1(JSON.parse(unit?.box1 || '[]'));
      setBox2(JSON.parse(unit?.box2 || '[]'));
      setSkillsHeading(unit?.skillsHeading || 'This Unit teaches skills for:');
      setHelpfulHeading(unit?.helpfulHeading || 'This Unit is helpful for students who:');
      setCompetency(JSON.parse(unit?.competency || '[]').join(', '));
    }
  }, [unit])


  const lastSession = useMemo(() => {
    let last = (unit as Unit)?.classPresentation?.sort((a, b) => (a?.lastVisitedAt === "" ? 0 : parseInt( a?.lastVisitedAt ?? '0')) - (b?.lastVisitedAt === "" ? 0 : parseInt(b?.lastVisitedAt ?? '0')))
    return timeCalc(parseInt(last?.at(last.length - 1)?.lastVisitedAt ?? '0'))
  }, [unit])

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.contentView}>
          <div className={styles.subContent}>Number of Lessons:&nbsp;<div style={{color: 'black'}}> {loading ? 'loading ...' :numberOfLessons}</div></div>
          <div className={styles.subContent}><div>Suggested Pace: </div>&nbsp;<span style={{color: 'black'}}>{unit?.pace}</span></div>
          <div className={styles.subContent}>Last Session Time: &nbsp;<div style={{color: 'black'}}>{lastSession}</div></div>
          <div className={styles.subContent}>Competency: <span style={{color: 'black'}}>&nbsp;{competency}</span></div>
        </div>
        <div className={styles.contentView}>
          <div className={styles.header}>
            <div className={styles.subTitle}>
              At a Glance:
            </div>
          </div>
          <div className={styles.tagView}>
          {(tags ?? []).map((o, index) => {
            const optionStr: string = o as string;
            return (
              <div key={index} className={styles.tagBox}>
                {optionStr}
              </div>
            );
          })}
          </div>
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.contentView}>
          <div className={styles.header}>
            <div className={styles.subTitle}>
              {skillsHeading}
            </div>
          </div>
          <ul className={styles.boxView}>
          {(box1 ?? []).map((o, index) => {
            const optionStr: string = o as string;
            return (
              <li key={index} className={styles.questionBox}>
                {optionStr}
              </li>
            );
          })}
          </ul>
        </div>
        
        <div className={styles.contentView}>
          <div className={styles.header}>
            <div className={styles.subTitle}>
              {helpfulHeading}
            </div>
          </div>
          <ul className={styles.boxView}>
          {(box2 ?? []).map((o, index) => {
            const optionStr: string = o as string;
            return (
              <li key={index} className={styles.questionBox}>
                {optionStr}
              </li>
            );
          })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default OverviewForm;